/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import { keyNames } from '@ba-ui-toolkit/constants';

export { keyNames };

export function getKeyName(e) {
	if (e.type === 'keydown' || e.type === 'keyup' || e.type === 'keypress') {
		const {
			BACKSPACE,
			TAB,
			ENTER,
			ESCAPE,
			SPACE,
			END,
			HOME,
			LEFT,
			UP,
			RIGHT,
			DOWN,
			A,
			F10,
			NOT_RECOGNIZED,
			SHIFT,
		} = keyNames;

		switch (
			e.keyCode ||
			e.which // older browser does not support e.keyCode
		) {
			case 8:
				return BACKSPACE;
			case 9:
				return TAB;
			case 13:
				return ENTER;
			case 16:
				return SHIFT;
			case 27:
				return ESCAPE;
			case 32:
				return SPACE;
			case 35:
				return END;
			case 36:
				return HOME;
			case 37:
				return LEFT;
			case 38:
				return UP;
			case 39:
				return RIGHT;
			case 40:
				return DOWN;
			case 65:
				return A;
			case 121:
				return F10;
			default:
				return NOT_RECOGNIZED;
		}
	} else {
		console.warn(`this event ${e} is not a keydown event`);
	}
}

export function isKey(e, keyName) {
	return getKeyName(e) === keyName;
}
